<template>
  <div class="committee">
    <h3 class="sub-title">ASCVTS Officer and Councilors</h3>
    <div class="list-group">
      <div class="list-group-item">
        <div class="list-group-content list-title">
          <div class="t-lt">Position</div>
          <div class="t-mid">Name</div>
          <div class="t-rt">Area</div>
        </div>
      </div>
      <div class="list-group-item" v-for="(item, index) in officers" :key="index">
        <div class="list-group-content">
          <div class="left">
            <span>{{item.position}}</span>
          </div>
          <div class="mid">{{item.name}}</div>
          <div class="right">{{item.area}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Officer",
  data() {
    return {
      officers: [
        {position: "Society President", name: "Sanghoon Jheon", area: "Seoul" },
        {position: "Secretary General, Scientific committee chair, Adult cardiac domain chair", name: "Minoru Ono", area: "Tokyo" },
        {position: "Treasurer, HP committee chair", name: "Jun Nakajima", area: "Tokyo" },
        {position: "Assistant SG in Seoul, 2023 Congress President, Aortic domain chair", name: "Kay Hyun Park", area: "Seoul" },
        {position: "Councilor, 2024 Congress President", name: "Nianguo Dong", area: "Wuhan" },
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.committee {
  .sub-title {
    font-weight: 900;
    font-size: 27px;
    line-height: normal;
    margin: 30px 0px 20px 0px;
    padding-bottom: 10px;
    border-bottom: solid 1px #ddd;
  }
  .list-group {
    .list-group-item {
      border: 1px solid rgba(0,0,0,.125);
      border-bottom: none;
      padding: 12px 20px;
      line-height: 26px;
      font-size: 16px;
      .list-group-content {
        display: flex;
        align-items: center;
        .t-lt {
          flex: 7;
        }
        .t-mid {
          flex: 2;
        }
        .t-rt {
          flex: 3;
        }
        .left {
          flex: 7;
          span {
            position: relative;
            &::before {
              content: "";
              position: absolute;
              left: 0;
              bottom: -3px;
              background: linear-gradient(to right, #19317e, #eaeff8);
              height: 3px;
              width: 100%;
            }
          }
        }
        .mid {
          flex: 2;
        }
        .right {
          flex: 3;
          font-family: "Akrobat Regular";
        }
        @media (max-width:992px) {
          display: block;
          &.list-title {
            div {
              display: none;
            }
          }
        }
      }
      &:first-child {
        border-radius: 4px 4px 0 0;
      }
      &:last-child {
        border-radius: 0 0 4px 4px;
        border-bottom: 1px solid rgba(0,0,0,.125);
      }
      &:nth-of-type(2n + 1) {
        background-color: #fafafa;
      }
    }
  }
}
</style>
